const BASE_URL = "https://core.teadrop.us/"

export default BASE_URL